import { FC, ReactElement, useMemo } from 'react'
import capitalize from 'lodash/capitalize'

import { RewardStatus } from 'interfaces/bounty'
import { RewardsStatusInColor } from 'components/features/pfm/RewardDetails/RewardStatusInColor/RewardStatusInColor'

type RewardsStatusLabelProps = {
  status: RewardStatus
  isCapitalized?: boolean
  isColoured?: boolean
  className?: string
}

const STATUSES_LABELS: Record<RewardStatus, string> = {
  confirmed: 'confirmed',
  cryptoConfirmed: 'confirmed',
  cryptoPending: 'pending',
  cryptoCancelled: 'cancelled',
  earned: 'earned',
  expired: 'expired',
  pending: 'pending',
}

export const RewardsStatusLabel: FC<RewardsStatusLabelProps> = ({
  status,
  isCapitalized,
  isColoured = true,
  className,
}): ReactElement => {
  const statusLabelNotFormatted: string = STATUSES_LABELS[status]
  const statusLabelFormatted: string = isCapitalized ? capitalize(statusLabelNotFormatted) : statusLabelNotFormatted
  const statusLabelFormattedAndColoured = useMemo<ReactElement>(() => (
    isColoured
      ? <RewardsStatusInColor status={ status } className={ className }>{ statusLabelFormatted }</RewardsStatusInColor>
      : <span className={ className }>{ statusLabelFormatted }</span>
  ), [statusLabelFormatted, status, isColoured, className])
  return statusLabelFormattedAndColoured
}
